/**
 * @generated SignedSource<<65556c2dc955dd85a81da86dd82b2677>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetContentScaffoldQuery$variables = {
  owner: string;
  slug: string;
};
export type DatasetContentScaffoldQuery$data = {
  readonly datasetBySlug: {
    readonly id: string;
    readonly versions: {
      readonly nodes: ReadonlyArray<{
        readonly analytics: {
          readonly " $fragmentSpreads": FragmentRefs<"DatasetAnalyticsFragment">;
        };
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionAsideContentFragment">;
      }>;
    };
    readonly votes: number;
  } | null | undefined;
};
export type DatasetContentScaffoldQuery = {
  response: DatasetContentScaffoldQuery$data;
  variables: DatasetContentScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "localSlug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v2/*:: as any*/),
  (v5/*:: as any*/)
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetContentScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DatasetVersionAsideContentFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetAnalytics",
                    "kind": "LinkedField",
                    "name": "analytics",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DatasetAnalyticsFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:1)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DatasetContentScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "DatasetVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "license",
                    "storageKey": null
                  },
                  (v6/*:: as any*/),
                  {
                    "alias": "viewerCanUpdate",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "UPDATE_DATASET_VERSION"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DOI",
                    "kind": "LinkedField",
                    "name": "doi",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "full",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "short",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dataset",
                    "kind": "LinkedField",
                    "name": "dataset",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v7/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "private",
                        "storageKey": null
                      },
                      {
                        "alias": "viewerCanUpdate",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "UPDATE_DATASET"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"UPDATE_DATASET\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersion",
                        "kind": "LinkedField",
                        "name": "latestVersion",
                        "plural": false,
                        "selections": (v8/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "latestCreatedVersion",
                        "args": (v4/*:: as any*/),
                        "concreteType": "DatasetVersionConnection",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DatasetVersion",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": (v8/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "versions(first:1)"
                      },
                      {
                        "alias": "versionsInput",
                        "args": (v9/*:: as any*/),
                        "concreteType": "DatasetVersionConnection",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DatasetVersionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DatasetVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v5/*:: as any*/),
                                  (v6/*:: as any*/),
                                  (v10/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v12/*:: as any*/)
                        ],
                        "storageKey": "versions(first:20)"
                      },
                      {
                        "alias": "versionsInput",
                        "args": (v9/*:: as any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "DatasetVersionCreateButtonFragment_versionsInput",
                        "kind": "LinkedHandle",
                        "name": "versions"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v10/*:: as any*/),
                          (v13/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isEntity"
                          },
                          (v14/*:: as any*/),
                          (v15/*:: as any*/),
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "tagList",
                            "args": (v16/*:: as any*/),
                            "concreteType": "TaggableConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                              (v17/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v10/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v12/*:: as any*/)
                            ],
                            "storageKey": "tags(first:5)"
                          },
                          {
                            "alias": "tagList",
                            "args": (v16/*:: as any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "TagListFragment_tagList",
                            "kind": "LinkedHandle",
                            "name": "tags"
                          }
                        ],
                        "type": "Taggable",
                        "abstractKey": "__isTaggable"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishable",
                    "storageKey": null
                  },
                  {
                    "alias": "viewerCanPublishDatasetVersion",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "PUBLISH_DATASET_VERSION"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
                  },
                  {
                    "alias": "authorsPreview",
                    "args": (v16/*:: as any*/),
                    "concreteType": "DatasetVersionAuthorConnection",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersionAuthorConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v11/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*:: as any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v13/*:: as any*/),
                                  (v14/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v15/*:: as any*/)
                                    ],
                                    "type": "Entity",
                                    "abstractKey": "__isEntity"
                                  }
                                ],
                                "type": "User",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullName",
                                    "storageKey": null
                                  }
                                ],
                                "type": "UnregisteredUser",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*:: as any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*:: as any*/)
                    ],
                    "storageKey": "authors(first:5)"
                  },
                  {
                    "alias": "authorsPreview",
                    "args": (v16/*:: as any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "DatasetVersionAsideContentAuthorsFragment_authorsPreview",
                    "kind": "LinkedHandle",
                    "name": "authors"
                  },
                  {
                    "alias": "authorsCount",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 0
                      }
                    ],
                    "concreteType": "DatasetVersionAuthorConnection",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": false,
                    "selections": [
                      (v17/*:: as any*/)
                    ],
                    "storageKey": "authors(first:0)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetAnalytics",
                    "kind": "LinkedField",
                    "name": "analytics",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fileSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "downloadCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:1)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4773b8f0b0d4e88d136866b76e5fe370",
    "id": null,
    "metadata": {},
    "name": "DatasetContentScaffoldQuery",
    "operationKind": "query",
    "text": "query DatasetContentScaffoldQuery(\n  $owner: String!\n  $slug: String!\n) {\n  datasetBySlug(owner: $owner, localSlug: $slug) {\n    id\n    votes\n    versions(first: 1) {\n      nodes {\n        id\n        ...DatasetVersionAsideContentFragment\n        analytics {\n          ...DatasetAnalyticsFragment\n        }\n      }\n    }\n  }\n}\n\nfragment DatasetAnalyticsFragment on DatasetAnalytics {\n  rowCount\n  fileSize\n  downloadCount\n}\n\nfragment DatasetDOIFragment on DatasetVersion {\n  id\n  doi {\n    full\n    short\n    url\n  }\n}\n\nfragment DatasetVersionAsideContentAuthorsFragment on DatasetVersion {\n  authorsPreview: authors(first: 5) {\n    edges {\n      cursor\n      node {\n        __typename\n        ... on User {\n          id\n          username\n          displayName\n          ...EntityProfilePicFragment_49kWkb\n        }\n        ... on UnregisteredUser {\n          fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment DatasetVersionAsideContentFragment on DatasetVersion {\n  id\n  version\n  license\n  publishedAt\n  viewerCanUpdate: viewerCan(action: UPDATE_DATASET_VERSION)\n  doi {\n    full\n  }\n  dataset {\n    id\n    slug\n    name\n    shortDescription\n    private\n    viewerCanUpdate: viewerCan(action: UPDATE_DATASET)\n    ...TagListFragment\n    ...DatasetVersionCreateButtonFragment\n  }\n  ...DatasetVersionCardFragment\n  ...DatasetVersionEditSheet\n  ...DatasetVersionAsideContentAuthorsFragment\n  ...DatasetDOIFragment\n  authorsCount: authors(first: 0) {\n    totalCount\n  }\n}\n\nfragment DatasetVersionCardFragment on DatasetVersion {\n  id\n  version\n  size\n  publishedAt\n  createdAt\n  updatedAt\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetVersionCreateButtonFragment on Dataset {\n  id\n  latestVersion {\n    id\n    version\n  }\n  latestCreatedVersion: versions(first: 1) {\n    nodes {\n      id\n      version\n    }\n  }\n  versionsInput: versions(first: 20) {\n    edges {\n      node {\n        id\n        version\n        publishedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DatasetVersionEditSheet on DatasetVersion {\n  id\n  version\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionPublishButtonFragment on DatasetVersion {\n  id\n  version\n  publishable @ifAllowed\n  viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagListFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...TagFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "4aa07db3c186b0c37f2aab215352d162";

export default node;
